import { getWellFunnelToken, setWellFunnelToken } from 'api/utils/tokenManagement';

import { AUTH_TOKEN_WELLFUNNEL_NAME } from 'constants/api';

import { initApiClient } from 'services/api/ApiClientService';
import { ERROR_LEVELS, SENTRY_AXIOS } from 'services/Sentry/constants';
import sentry from 'services/Sentry/SentryInstance';

const MAX_RETRIES = 3;

const ApiClientWellFunnel = () => {
    return initApiClient({
        apiVersion: import.meta.env.WELLFUNNEL_API_VERSION,
        apiUrl: import.meta.env.WELLFUNNEL_API_URL,
        apiKey: import.meta.env.WELLFUNNEL_API_KEY,
        retries: MAX_RETRIES,
        timeout: 35000,
        authTokenKey: AUTH_TOKEN_WELLFUNNEL_NAME,
        headers: {
            'project-id': import.meta.env.PROJECT_ID,
        },
        headerTokenKey: 'token',
        getAuthToken: () => getWellFunnelToken(),
        onUpdateToken: (token) => {
            setWellFunnelToken(token);
        },
        onErrorHandler: ({ extras, status, message }) => {
            const level = Number(status) >= 500 ? ERROR_LEVELS.CRITICAL : ERROR_LEVELS.ERROR;

            sentry.logError(new Error(message), SENTRY_AXIOS, level, extras);
        },
    });
};

export default ApiClientWellFunnel();
